var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"py-10 py-sm-16",attrs:{"id":"why_us"}},[_c('v-container',[_c('v-row',{staticClass:"mb-10 text-center",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',{class:[
            'font-weight-bold',
            _vm.$vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h4',
          ]},[_vm._v(" "+_vm._s(_vm.$t("section_3_title"))+" ")])])],1),_c('v-row',_vm._l((_vm.whyUs),function(card,i){return _c('whyUsCard',{key:i,attrs:{"image":card.image,"points":card.points}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }